<div class="flex-fill d-flex flex-column">
  <div class="m-1 grid-fill">
    <dx-data-grid
      #dataGrid
      [dataSource]="invoices"
      keyExpr="id"
      [columnAutoWidth]="false"
      (onSelectionChanged)="selectionChange($event)"
      (onRowDblClick)="rowDoubleClick($event)"
      (onExporting)="onExporting($event)"
      >
      <!-- <dxi-column dataField="id" width="40"></dxi-column> -->
      <dxi-column dataField="invoiceNumber" caption="Invoice #" width="80"></dxi-column>
      <dxi-column dataField="invoiceType.name" caption="Type" width="80"></dxi-column>
      <dxi-column dataField="customer.companyName" caption="Customer" width="200"></dxi-column>
      <dxi-column dataField="shipTo" width="200"></dxi-column>
      <dxi-column dataField="invoiceDate" caption="Date" width="100"></dxi-column>
      <dxi-column dataField="statusName" caption="Status" width="100"></dxi-column>
      <dxi-column dataField="subTotal" width="100" [format]="{ type: 'currency', precision: 2 }" [calculateCellValue]="calculateSubTotal"></dxi-column>
      <dxi-column dataField="tax" width="100" [format]="{ type: 'currency', precision: 2 }" [calculateCellValue]="calculateTax"></dxi-column>
      <dxi-column dataField="total" width="100" [format]="{ type: 'currency', precision: 2 }" [calculateCellValue]="calculateTotal"></dxi-column>
      <dxi-column dataField="balance" width="100" [format]="{ type: 'currency', precision: 2 }" [calculateCellValue]="calculateBalance"></dxi-column>
      <dxi-column dataField="ticketType" width="150"></dxi-column>
      <dxi-column dataField="customer.preferredCommunication" caption="Comm." width="100"></dxi-column>
      <dxi-column dataField="isMail" width="100"></dxi-column>
      <dxi-column dataField="isEmail" width="100"></dxi-column>
      <dxi-column dataField="customer.email" caption="Email" width="200"></dxi-column>
      <dxi-column dataField="emailed" caption="Sent" width="200" [format]="{type: 'shortDateShortTime'}"></dxi-column>
      <dxi-column width="100"></dxi-column>

      <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="invoice-search-grid"></dxo-state-storing>
      <dxo-selection [mode]="'multiple'"></dxo-selection>
      <dxo-sorting [mode]="'multiple'"></dxo-sorting>
      <dxo-summary>
        <dxi-total-item column="subTotal" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"></dxi-total-item>
        <dxi-total-item column="tax" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"></dxi-total-item>
        <dxi-total-item column="total" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"></dxi-total-item>
        <dxi-total-item column="balance" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'currency', precision: 2 }"></dxi-total-item>
      </dxo-summary>

      <div *dxTemplate="let data of 'toolbarButtons'">
        <button class="btn btn-sm btn-success" (click)="open()">New</button>
        <button
          class="btn btn-sm btn-primary ms-2"
          (click)="open(dataGrid.instance.getSelectedRowsData()[0])"
          [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
          >
          Open
        </button>
        <button class="btn btn-sm btn-danger ms-4" (click)="delete()" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">Delete</button>
        <button
          class="btn btn-sm btn-primary ms-4"
          (click)="print(dataGrid.instance.getSelectedRowsData())"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Print
        </button>
        <button
          class="btn btn-sm btn-primary ms-2"
          (click)="sendToQueue(dataGrid.instance.getSelectedRowsData())"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Email
        </button>
        <button
          class="btn btn-sm btn-primary ms-3"
          (click)="quickFinanceCharge(dataGrid.instance.getSelectedRowsData())"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Quick Finance Charge
        </button>
        <button  class="btn btn-sm btn-warning ms-4" (click)="toggleShowAll()">{{ filter.showAll ? 'Show Recent': 'Show All' }}</button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (invoices) {
          <span class="me-3"
            ><strong
            >{{ dataGrid.instance.totalCount() + " items" }}
            {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
          </strong></span
          >
        }
      </div>
    </dx-data-grid>
  </div>
</div>
